module.exports = __webpack_public_path__ + "static/media/Aurora-Consulting.692fb621.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/screenshots/Aurora-Consulting.png
// module id = 91
// module chunks = 0